import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { UserIdService } from '../../../../core/auth';
import { BuyerData } from '../../../../core/model';
import { CartConnector } from '../connector/cart.connector';
import { BuyerDataFacade } from '../facades';

@Injectable()
export class BuyerDataService implements BuyerDataFacade {
  constructor(private cartConnector: CartConnector, private userIdService: UserIdService) {}

  getBuyerData(cartId: string): Observable<BuyerData> {
    return this.userIdService.getUserId().pipe(
      take(1),
      switchMap((userId) => this.cartConnector.buyerData(userId, cartId))
    );
  }
}
